import { render, staticRenderFns } from "./PonEletronicoPrincipal.vue?vue&type=template&id=54c3fc9d&"
import script from "./PonEletronicoPrincipal.vue?vue&type=script&lang=js&"
export * from "./PonEletronicoPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports